export default Object.freeze({
  publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  apiKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
});
